module.exports = __webpack_public_path__ + "img/pic2.9564bbad.png";